<template>
  <div class="bg-white">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane v-for="item in servertype" :key="item.value" :label="item.label" :name="item.name"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="serverList"
      header-row-class-name="table-header"
      row-class-name="table-row"
      alig="center"
      border
      style="width: 100%"
    >
      <el-table-column width="70" type="index" align="center" label="序号">
      </el-table-column>
      <el-table-column label="服务内容" prop="content" width="500"></el-table-column>
      <el-table-column label="积分" prop="score"></el-table-column>
      <el-table-column label="操作" >
        <template slot-scope="scope">
          <div class="table-operate">
            <el-button
              size="small"
              type="primary"
              @click="editItem(scope.row)"
            >编辑
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click="deleteItem(scope.row.id)"
            >删除
            </el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="flex align-center justify-around margin-top">
      <el-button type="primary" @click="serverDialog=true">添加服务类目</el-button>
    </div>
    <serverContentDialog
      :setId="setId"
      :setItem="setItem"
      :activeIndex="activeIndex"
      :serverDialog="serverDialog"
      @cancelDialog="cancelDialog"
    />
  </div>
</template>

<script>
import {delProjectService, projectServiceList} from "@/api/weilao";
import serverContentDialog from "@/views/pages/sndialog/serverContentDialog";
export default {
  name: "server-category",
  data() {
    return {
      servertype: [],
      activeName:'frist',
      activeIndex:0,
      serverList:[],
      serverDialog:false,
      setId: 0,
      setItem: {},
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    server() {
      return this.$store.state.server
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "双暖为老 / 服务类目管理", false);
    this.servertype =  this.server.length > 0 ? this.server : [{label: '搬', name: 'frist', value: 1},
      {label: '扫', name: 'second', value: 2},
      {label: '换', name: 'third', value: 3},
      {label: '访', name: 'fourth', value: 4},]
    this.getServerList()
  },
  components: {
    serverContentDialog
  },
  methods: {
    //  删除服务类目
    deleteItem(id){
      this.$confirm('您确定要删除该服务类目吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await delProjectService(id);
      this.getServerList();
      this.$message.success(_state.info);
    },
    //  编辑服务类目
    editItem(obj){
      this.setItem = obj
      this.setId = obj.id
      this.serverDialog = true;
    },
    //  关闭弹框
    cancelDialog() {
      this.setId = 0;
      this.setItem = {};
      this.serverDialog = false;
      this.getServerList();
    },
    //  获取当前类型下服务
    async getServerList(){
      let _cate = this.activeIndex + 1
      let _data = await projectServiceList(_cate)
      this.serverList =  _data.data
    },

    //  类型切换
    handleClick(tab) {
      this.activeIndex = Number(tab.index)
    }
  },
  filters: {},
  watch: {
    activeIndex(){
      this.getServerList()
    }
  },
}
</script>

<style scoped lang="scss">

</style>
